import {ConfigurationModel} from './../models/configuration.model';
import {LokijsService} from 'src/app/services/database/lokijs.service';
import {Injectable, OnInit} from '@angular/core';
import {ConfigurationDefault} from '../definitions/configuration-default';
import {UrlEndpoints} from '../definitions/url-endpoints';
import {MobileConfigurationModel} from '../models/mobile-configuration.model';
import {ScreenPreferencesDefault} from '../definitions/screen-preferences-default';
import {ScreenPreferencesModel} from '../models/screen-preferences.model';
import {SysConfigModel} from '../models/sys-config.model';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';

declare global {
    interface Window {
        connectionConfig: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService implements OnInit {
    configuration: ConfigurationModel; // default values
    screenPreferences: ScreenPreferencesModel;
    runningInBackground = false;
    CURRENTDATABASEVERSION = 2;

    constructor(private loki: LokijsService,
                private configDefault: ConfigurationDefault,
                private UrlEndPoint: UrlEndpoints,
                private screenPrefDefinition: ScreenPreferencesDefault,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    ngOnInit() {
    }

    init() {
        const configColl: any = this.stateManager.getCollection('configuration');
        console.log(configColl);
        if (configColl.length !== 0) {
            this.configuration = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        } else {
            this.configuration = this.configDefault.configuration;
            this.stateManager.upsert(this.collectionNames.CONFIGURATION, '$loki', this.configuration);
            console.log('Configuration inserted');
        }

        const prefColl: any = this.stateManager.getCollection('screenpreferences');
        if (prefColl.length <= 0) {
            this.screenPreferences = this.screenPrefDefinition.screenPreferences;
            this.stateManager.upsert(this.collectionNames.SCREENPREFERENCES, '$loki', this.screenPreferences);
        }
        // handle customer configuration if present
        if (window.connectionConfig && window.connectionConfig.hostname) {
            // const connectionConfig = JSON.parse( window.connectionConfig );
            this.configuration.host = window.connectionConfig.hostname;
            this.configuration.port = window.connectionConfig.port;
        }
    }

    buildUrl(endPoint: string) {
        this.configuration = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        return this.getProtoCol() + this.configuration.host + ':' + this.configuration.port +
            this.getService() + endPoint;
    }

    buildErrorLoggingURL() {
        this.configuration = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        // return this.getProtoCol() + this.configuration.host + ':' + this.configuration.port + this.UrlEndPoint.loggingPostEndPoint;
        return this.getProtoCol() + this.configuration.host + ':' + this.configuration.port + this.UrlEndPoint.loggingPostEndPoint;
    }

    getProtoCol() {
        return this.configuration.port === 443 ? 'https://' : 'http://';
    }

    getService() {
        return '/BusinessLogicServices';
    }

    getConfiguration(): ConfigurationModel {
        return this.loki.getCollection('configuration').get(1);
    }

    getMobileConfiguration(): MobileConfigurationModel {
        return this.loki.getCollection('mobileconfiguration').get(1);
    }

    getSystemConfiguration(): SysConfigModel[] {
        return this.loki.getCollection('systemconfiguration').chain().data();
    }

    getScreenPreferences(): ScreenPreferencesModel {
        return this.loki.getCollection('screenpreferences').get(1);
    }

    saveConfiguration(config: ConfigurationModel) {
        this.loki.getCollection('configuration').update(config);
    }

    saveScreenPreferences(pref: ScreenPreferencesModel) {
        this.loki.getCollection('screenpreferences').update(pref);
    }

    checkConfiguration() {
        console.log(Object.keys(this.configuration).length);
        console.log(Object.keys(this.configDefault.configuration).length);
        if (Object.keys(this.configuration).length - 2 < Object.keys(this.configDefault.configuration).length) {
            const tempConfig = JSON.parse(JSON.stringify(this.getConfiguration()));
            this.loki.getCollection('configuration').clear();
            this.saveConfiguration(tempConfig);
        }
    }
}
